var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-card-content" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-radio", {
                attrs: {
                  label: _vm.$ct("weekly"),
                  name: _vm.uid,
                  "element-value": _vm.weeklyValue + "",
                  checked: _vm.isChecked(_vm.weeklyValue),
                },
                on: {
                  input: function ($event) {
                    return _vm.setVal(_vm.weeklyValue)
                  },
                },
              }),
              _c("w-radio", {
                attrs: {
                  label: _vm.$ct("monthly"),
                  name: _vm.uid,
                  "element-value": _vm.monthlyValue + "",
                  checked: _vm.isChecked(_vm.monthlyValue),
                },
                on: {
                  input: function ($event) {
                    return _vm.setVal(_vm.monthlyValue)
                  },
                },
              }),
              _c("w-radio", {
                attrs: {
                  label: _vm.$ct("monthly-per-week"),
                  name: _vm.uid,
                  "element-value": _vm.monthlyPerWeekValue + "",
                  checked: _vm.isChecked(_vm.monthlyPerWeekValue),
                },
                on: {
                  input: function ($event) {
                    return _vm.setVal(_vm.monthlyPerWeekValue)
                  },
                },
              }),
              _c("w-radio", {
                attrs: {
                  label: _vm.$ct("yearly"),
                  name: _vm.uid,
                  "element-value": _vm.yearlyValue + "",
                  checked: _vm.isChecked(_vm.yearlyValue),
                },
                on: {
                  input: function ($event) {
                    return _vm.setVal(_vm.yearlyValue)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }